import { defineMessages } from 'react-intl';

export default defineMessages({
  date: {
    id: 'event_schedule_type.date.title',
    defaultMessage: 'Date',
  },
  recurrence: {
    id: 'event_schedule_type.recurrence.title',
    defaultMessage: 'Recurrence'
  },
  interval: {
    id: 'event_schedule_type.interval.title',
    defaultMessage: 'Interval'
  },
});
